const KEY = "blu-bubble-variant";
export const BLU_BUBBLE_VARIANTS = ["compact", "split", "stack"];
export const BLU_OPEN_EVENT = "blu-open";

export function getBluBubbleVariant() {
  try {
    const v = localStorage.getItem(KEY);
    if (BLU_BUBBLE_VARIANTS.includes(v)) return v;
  } catch {
    /* ignore */
  }
  return "compact"; // production default
}

export function setBluBubbleVariant(variant) {
  if (!BLU_BUBBLE_VARIANTS.includes(variant)) return;
  try {
    localStorage.setItem(KEY, variant);
  } catch {
    /* ignore */
  }
}

/**
 * Open the BLU bubble. Optional seed:
 * `{ clientId, clientName, engagement_stage, text }` — binds the thread + prefills composer.
 */
export function openBluBubble(variantOrSeed, maybeSeed) {
  const seed =
    variantOrSeed && typeof variantOrSeed === "object" && !Array.isArray(variantOrSeed)
      ? variantOrSeed
      : maybeSeed && typeof maybeSeed === "object"
        ? maybeSeed
        : null;
  const variant =
    typeof variantOrSeed === "string"
      ? variantOrSeed
      : typeof seed?.variant === "string"
        ? seed.variant
        : undefined;
  if (variant) setBluBubbleVariant(variant);
  if (typeof window !== "undefined") {
    window.dispatchEvent(
      new CustomEvent(BLU_OPEN_EVENT, {
        detail: { variant, seed: seed || null },
      }),
    );
  }
}
